import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollTop from "@/components/feature/ScrollTop";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-950">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollTop />
    </div>
  );
}